import React, { useEffect } from 'react';
import { Box, Typography, Container, Paper, Divider, Stack, Button } from '@mui/material';
import { IoShieldCheckmarkOutline, IoArrowBack, IoLockClosedOutline, IoPersonOutline, IoShareSocialOutline, IoMailOutline, IoCheckmarkCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import logo from './img/logoDs.png';

export default function PoliticaPrivacidad() {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sections = [
        {
            icon: <IoPersonOutline size={22} color="#53FC18" />,
            title: "1. Información que Recopilamos",
            content: (
                <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.8, fontSize: '0.95rem' }}>
                    Recopilamos información que el usuario proporciona de forma voluntaria al interactuar con nuestra plataforma y aplicación móvil <strong>D-SIDE / Eldenguee</strong>, incluyendo:
                    <br /><br />
                    • <strong>Datos de Usuario y Cuenta:</strong> Nombre de usuario en plataformas vinculadas (Kick, entre otros) e identificadores públicos de perfil.<br />
                    • <strong>Datos Técnicos y de Dispositivo:</strong> Dirección IP, tipo de navegador, sistema operativo y registros de actividad estrictamente necesarios para la prevención de fraudes y seguridad.
                </Typography>
            )
        },
        {
            icon: <IoShieldCheckmarkOutline size={22} color="#0088cc" />,
            title: "2. Uso de la Información",
            content: (
                <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.8, fontSize: '0.95rem' }}>
                    La información recopilada es utilizada exclusivamente para:
                    <br /><br />
                    • Validar y gestionar sorteos, recompensas, códigos promocionales y eventos en vivo.<br />
                    • Verificar la identidad del usuario y prevenir multicuentas, bots o accesos no autorizados.<br />
                    • Mantener la estabilidad operativa, seguridad y el correcto funcionamiento de las funciones interactivas.<br />
                    • Brindar soporte al usuario y atender consultas o reclamos.
                </Typography>
            )
        },
        {
            icon: <IoLockClosedOutline size={22} color="#53FC18" />,
            title: "3. Protección y Seguridad de los Datos",
            content: (
                <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.8, fontSize: '0.95rem' }}>
                    Implementamos medidas de seguridad técnicas, organizativas y protocolos de cifrado (SSL/HTTPS) para salvaguardar tu información personal frente a accesos no autorizados, alteración, divulgación o destrucción no permitida.
                </Typography>
            )
        },
        {
            icon: <IoShareSocialOutline size={22} color="#0088cc" />,
            title: "4. Divulgación a Terceros",
            content: (
                <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.8, fontSize: '0.95rem' }}>
                    <strong>No vendemos, comercializamos ni alquilamos</strong> tus datos personales a terceros. La información sólo podrá ser compartida con servicios de infraestructura y autenticación necesarios para la prestación del servicio (como la API de Kick bajo consentimiento del usuario) o cuando sea requerido por ley.
                </Typography>
            )
        },
        {
            icon: <IoCheckmarkCircle size={22} color="#53FC18" />,
            title: "5. Derechos del Usuario y Eliminación de Datos",
            content: (
                <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.8, fontSize: '0.95rem' }}>
                    El usuario tiene derecho a solicitar el acceso, rectificación o eliminación total de sus datos almacenados en nuestros registros en cualquier momento. Para ejercer estos derechos, puede comunicarse directamente a través de nuestros canales oficiales de contacto.
                </Typography>
            )
        },
        {
            icon: <IoMailOutline size={22} color="#0088cc" />,
            title: "6. Contacto",
            content: (
                <Typography variant="body2" sx={{ color: '#D1D5DB', lineHeight: 1.8, fontSize: '0.95rem' }}>
                    Si tenés preguntas, inquietudes o querés solicitar la supresión de tus datos relacionados con esta Política de Privacidad, podés contactarnos a través de nuestra comunidad oficial o correo electrónico:
                    <br /><br />
                    <strong>Contacto:</strong> soporte@eldenguee.com<br />
                    <strong>Sitio Web:</strong> https://eldenguee.com
                </Typography>
            )
        }
    ];

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: '#0b0e14',
                color: '#FFF',
                fontFamily: 'Outfit, sans-serif',
                py: { xs: 4, sm: 6 },
                px: { xs: 2, sm: 3 },
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* Background Glows */}
            <Box
                sx={{
                    position: 'absolute',
                    width: 500,
                    height: 500,
                    borderRadius: '50%',
                    background: '#53FC18',
                    filter: 'blur(200px)',
                    opacity: 0.05,
                    top: -100,
                    left: -100,
                    pointerEvents: 'none',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    width: 450,
                    height: 450,
                    borderRadius: '50%',
                    background: '#0088cc',
                    filter: 'blur(200px)',
                    opacity: 0.08,
                    bottom: 0,
                    right: -100,
                    pointerEvents: 'none',
                }}
            />

            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Back button */}
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Button
                        startIcon={<IoArrowBack />}
                        onClick={() => navigate(-1)}
                        sx={{
                            color: '#9CA3AF',
                            textTransform: 'none',
                            fontWeight: 700,
                            borderRadius: '12px',
                            border: '1px solid rgba(255,255,255,0.1)',
                            bgcolor: 'rgba(255,255,255,0.03)',
                            px: 2,
                            py: 0.8,
                            '&:hover': {
                                color: '#FFF',
                                borderColor: 'rgba(255,255,255,0.25)',
                                bgcolor: 'rgba(255,255,255,0.08)',
                            }
                        }}
                    >
                        Volver
                    </Button>

                    <img src={logo} alt="D-SIDE Logo" style={{ width: 44, height: 44, objectFit: 'contain' }} />
                </Box>

                {/* Main Card */}
                <Paper
                    elevation={0}
                    sx={{
                        backgroundColor: 'rgba(15, 20, 32, 0.95)',
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: { xs: 4, sm: 6 },
                        p: { xs: 3, sm: 5 },
                        boxShadow: '0 25px 60px rgba(0,0,0,0.5)',
                        backdropFilter: 'blur(16px)',
                    }}
                >
                    {/* Header */}
                    <Box sx={{ textAlign: 'center', mb: 4 }}>
                        <Box
                            sx={{
                                width: 64,
                                height: 64,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, rgba(83,252,24,0.2) 0%, rgba(0,136,204,0.2) 100%)',
                                border: '1px solid rgba(83,252,24,0.4)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 2,
                            }}
                        >
                            <IoShieldCheckmarkOutline size={32} color="#53FC18" />
                        </Box>
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 800,
                                fontFamily: 'Outfit, sans-serif',
                                color: '#FFF',
                                fontSize: { xs: '1.75rem', sm: '2.25rem' },
                                mb: 1,
                            }}
                        >
                            Política de Privacidad
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '0.85rem' }}>
                            Última actualización: Septiembre 2026 • <strong>Eldenguee / D-SIDE</strong>
                        </Typography>
                    </Box>

                    <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', mb: 4 }} />

                    {/* Introducción */}
                    <Typography variant="body1" sx={{ color: '#E5E7EB', lineHeight: 1.8, mb: 4, fontSize: '0.95rem' }}>
                        En <strong>Eldenguee / D-SIDE</strong> nos tomamos muy en serio la privacidad y la protección de los datos de nuestros usuarios. Esta Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos la información al acceder a nuestro sitio web y aplicación móvil.
                    </Typography>

                    {/* Secciones */}
                    <Stack spacing={3}>
                        {sections.map((section, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    p: { xs: 2.5, sm: 3 },
                                    borderRadius: '16px',
                                    bgcolor: 'rgba(0, 0, 0, 0.25)',
                                    border: '1px solid rgba(255, 255, 255, 0.05)',
                                    transition: '0.2s ease',
                                    '&:hover': {
                                        borderColor: 'rgba(83, 252, 24, 0.2)',
                                        bgcolor: 'rgba(0, 0, 0, 0.35)',
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
                                    {section.icon}
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: '#FFF',
                                            fontSize: { xs: '1.05rem', sm: '1.15rem' },
                                            fontFamily: 'Outfit, sans-serif'
                                        }}
                                    >
                                        {section.title}
                                    </Typography>
                                </Box>
                                {section.content}
                            </Box>
                        ))}
                    </Stack>

                    <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', my: 4 }} />

                    <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="caption" sx={{ color: '#6B7280', display: 'block' }}>
                            © 2026 Eldenguee / D-SIDE. Todos los derechos reservados.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}
